// frontend/src/pages/settings/users-roles/RoleList.tsx
import { Lock, Plus, Users } from 'lucide-react';
import type { RoleSummary } from './types';

interface Props {
  roles: RoleSummary[];
  selectedId: number | null;
  onSelect: (id: number) => void;
  onNew: () => void;
}

export function RoleList({ roles, selectedId, onSelect, onNew }: Props) {
  return (
    <div className="lg:w-64 shrink-0 space-y-2">
      <nav className="bg-[var(--color-bg)] rounded-lg border border-[var(--color-border)] overflow-hidden">
        {roles.map((r) => (
          <button
            key={r.id}
            onClick={() => onSelect(r.id)}
            className={`w-full text-left px-4 py-3 text-sm border-b border-[var(--color-border)] last:border-0 transition-colors ${
              selectedId === r.id
                ? 'bg-[var(--color-primary-light)] text-[var(--color-primary)] font-medium'
                : 'text-[var(--color-text-secondary)] hover:bg-[var(--color-surface-hover)]'
            }`}
          >
            <div className="flex items-center justify-between gap-2">
              <span className="flex items-center gap-1.5 truncate">
                {r.is_admin && <Lock size={12} />}
                {r.name}
              </span>
              <span className="flex items-center gap-1 text-[11px] text-[var(--color-text-muted)]">
                <Users size={11} /> {r.user_count}
              </span>
            </div>
            {!r.is_system && <div className="text-[10px] text-[var(--color-text-muted)] mt-0.5">personalizado</div>}
          </button>
        ))}
      </nav>
      <button
        onClick={onNew}
        className="w-full flex items-center justify-center gap-2 px-3 py-2 text-sm rounded-lg border border-dashed border-[var(--color-border)] text-[var(--color-text-secondary)] hover:bg-[var(--color-surface-hover)]"
      >
        <Plus size={14} /> Nuevo rol
      </button>
    </div>
  );
}
